<div [ngClass]="'acc-body' + (_expanded ? ' expanded' : ' collapsed')" #body>
  <div #container class="acc-container">
    <ng-content></ng-content>
  </div>
</div>
